import { useEffect, useMemo, useState } from 'react'
import { useQuery } from "@apollo/client"
import { bitkubActionResolutionType, bitkubActionsQuery, bitkubActionStrategyType, currencyToSignalActionsMapType } from 'src/types/bitkub-action-types'
import { BITKUB_ACTIONS } from 'src/graphql/queries/bitkubAction'

interface hookProps {
  strategyType : bitkubActionStrategyType
  resolution : bitkubActionResolutionType
}

const useBitkubActionsQuery = (props:hookProps) => {
  const [currencyToSignalActionsMap,setCurrencyToSignalActionsMap] = useState<currencyToSignalActionsMapType>({});
  const {data, ...query} = useQuery<bitkubActionsQuery>(BITKUB_ACTIONS, {
		variables : props,
    skip : !props.strategyType || !props.resolution
	})

  const getCurrency = (symbol:string) => {
    try {
      let symbolArr = symbol.split("_")
      if (symbolArr[0] === "THB") return symbolArr[1]
      if (symbolArr[1] === "THB") return symbolArr[0]
      return "UNK"
    } catch(_) {
      return "UNK"
    }
  }

  const response = useMemo(() => {
		const payload = data?.bitkubActions
		if(payload?.__typename === "BitkubActionsOutPut") return payload.actions
    return []
	},[data])

  const responseError = useMemo(()=>{
    const payload = data?.bitkubActions
		if(payload?.__typename === "Error") return payload
    return undefined
  },[data])

  useEffect(()=>{
    let mapper:currencyToSignalActionsMapType = {}
    response.forEach((action)=>{
      let currency = getCurrency(action.symbol)
      mapper[currency] = action
    })
    setCurrencyToSignalActionsMap(mapper)
  },[response])

  return {
    data:response,
    error:responseError,
    currencyToSignalActionsMap:currencyToSignalActionsMap,
    query,
  }
}

export default useBitkubActionsQuery